import React from 'react'
import fundebug from 'fundebug-javascript'

fundebug.apikey = '912a5ee85b90f339a91348d5746f06d4ad1527468a0ff5eba40db4a4b2554f47'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hasError: false
    }
  }

  componentDidCatch (error, info) {
    this.setState({ hasError: true })
    // 将component中的报错发送到Fundebug
    fundebug.notifyError(error, {
      metaData: {
        info
      }
    })
  }

  render () {
    if (this.state.hasError) {
      // 勿返回 null：否则会整页白屏，移动端 Safari / WebView 上易被误判为「打不开」
      return (
        <div style={{ padding: 24, maxWidth: 480, margin: '40px auto', fontSize: 14, color: 'rgba(0,0,0,.85)' }}>
          <p style={{ marginBottom: 8 }}>页面加载出现异常。</p>
          <p style={{ color: 'rgba(0,0,0,.45)' }}>请尝试刷新页面；若仍失败请联系技术支持。</p>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
